(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cbx-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cbx-product-description')) {
  customElements.define('cbx-product-description', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      this.content = this.querySelector('[data-description-content]');
      this.button = this.querySelector('[data-description-toggle]');
      if (!this.content || !this.button) return;
      this.expanded = false;
      this.button.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.update();
      }, { signal: this.abort.signal });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.content);
      this.content.addEventListener('load', () => this.update(), { capture: true, signal: this.abort.signal });
      document.fonts.ready.then(() => { if (this.isConnected) this.update(); });
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    update() {
      const style = getComputedStyle(this.content);
      const limit = (parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5) * 2;
      this.style.setProperty('--description-height', `${limit}px`);
      const overflows = this.content.scrollHeight > limit + 2;
      if (!overflows) this.expanded = false;
      this.classList.toggle('is-collapsed', overflows && !this.expanded);
      this.button.hidden = !overflows;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.querySelector('[data-description-label]').textContent = this.expanded ? 'Read Less' : 'Read More';
      this.querySelector('[data-description-arrow]').textContent = this.expanded ? '↑' : '→';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
